import request from "@/utils/request";

// 查询轮播图信息列表
export function getBannerList() {
  return request({
    url: '/web/getBannerList',
    method: 'get'
  })
}
